const CciHsPastClassificationApiUrls = {
    GET: `${process.env.REACT_APP_USER_CCI_URL}/cci/hs-transaction/get`,
    EXPORT: `${process.env.REACT_APP_USER_CCI_URL}/cci/hs-transaction/download`,
    EXPORT_CSV: `${process.env.REACT_APP_USER_CCI_URL}/cci/hs-transaction/downloadCSV`,
};
export default CciHsPastClassificationApiUrls